<div class="monitoring mt-32" [class.no-animation]="noAnimation">
  <div class="monitoring__header" #monitoringHeaderWrapper>
    <div class="wrapper__header" #monitoringHeaderFixed>
      <app-employee-statuses-filter [filter]="filter"></app-employee-statuses-filter>

      <div class="header__days mt-24">
        <div class="days__left-block"></div>
        <div class="days-block js-days-block">
          <div class="days-block__wrapper-block">
            <div class="days-block__wrapper" [class.days-block__wrapper-grs]="isGRS" #wrapperHeaderDaysSlide>
              <div class="day-block" *ngFor="let d of times">
                <div class="next-date-one">
                  {{ d.date | dateFormat: 'DD MMMM YYYY' }}
                </div>
                <div class="next-date-two">
                  {{ d.date | dateFormat: 'DD MMMM YYYY' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="days__right-block"></div>
      </div>
      <div class="header__items">
        <div class="header__item header__item-name font-weight-bold">ФИО</div>
        <div class="header__item header__item-work-day font-weight-bold">График</div>
        <div class="header__item header__item-left-nav">
          <button class="item-time__nav item-time__nav-left" [attr.disabled]="isClickPrevented" type="button" (click)="onPrevSlide()">
            <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'blue-dark'"></app-icon>
          </button>
        </div>
        <div class="header__item header__item-time" #headerItemTime>
          <div class="header-time-block__wrapper-block">
            <div class="header-time-block__wrapper" [class.header-time-block__wrapper--grs]="isGRS" #wrapperHeaderSlide>
              <div class="header-time-block" *ngFor="let intervalHeader of times" [attr.data-header-date]="intervalHeader.date">
                <div class="header-time-block__item" *ngFor="let i of intervalHeader.times; let index = index" id="{{ 'time_' + intervalHeader.date + '_' + index }}">
                  {{ i }}
                </div>
                <app-current-time [currentTime]="filter.currentTime" *ngIf="filter.currentTime"></app-current-time>
              </div>
            </div>
          </div>
        </div>
        <div class="header__item header__item-right-nav">
          <button class="item-time__nav item-time__nav-right" type="button" [attr.disabled]="isClickPrevented" (click)="onNextSlide()">
            <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'blue-dark'"></app-icon>
          </button>
        </div>
        <div class="header__item header-item__worked font-weight-bold">Отработано</div>
      </div>
    </div>
  </div>
  <div>
    <div class="monitoring__content" #monitoringContent>
      <app-loader *ngIf="loading"></app-loader>
      <ng-container *ngIf="employers && employers.length">
        <div class="content-items" *ngFor="let employee of employers" [attr.data-employee-id]="employee.u_id">
          <div class="content-item content-item__name">
            <div class="pr-2">
              <div class="text-ellipsis">
                {{ employee.employee.full_name }}
              </div>
              <div class="grid grid--gap-8">
                <div class="grid__box grid__box--size-min">
                  <app-user-popover [user]="employee"></app-user-popover>
                </div>
                <div class="grid__box grid__box--size-min">
                  <app-way-movement [status]="employee.worklog && employee.worklog.transport"></app-way-movement>
                </div>
              </div>
            </div>
          </div>
          <div class="content-item content-item__work-day">
            <div class="grid grid--va-middle grid--gap-8" *ngIf="employee.currentWorkDay && employee.currentWorkDay.isWorked">
              <div class="grid__box grid__box--size-min">
                <div
                  *ngIf="!employee.currentWorkDay.isWorkedOtherSector"
                  class="cell-square {{ 'cell-square--' + Enums.cellSquare[employee.currentWorkDay.cellType.ct_id] }}"
                ></div>
                <div *ngIf="employee.currentWorkDay.isWorkedOtherSector" class="cell-square {{ 'cell-square--' + Enums.cellSquare[2] }}"></div>
              </div>
              <div class="grid__box grid__box--size-min">
                <a
                  class="link"
                  target="_blank"
                  [routerLink]="[
                    '/',
                    WORK_SHIFTS_PATHS.work_shifts,
                    {
                      sector_id: employee.sector_id,
                      full_name: employee.employee.full_name,
                      int_begin: filter.calendar.linkDate
                    }
                  ]"
                >
                  <span *ngIf="employee.currentWorkDay.isWorkedOtherSector"> Командировка </span>
                  <span *ngIf="!employee.currentWorkDay.isWorkedOtherSector">
                    <span *ngIf="employee.currentWorkDay.cellType && employee.currentWorkDay.cellType.ct_id === 1">
                      {{ employee.currentWorkDay.int_begin | dateFormat: 'HH:mm' }}
                      -
                      {{ employee.currentWorkDay.int_end | dateFormat: 'HH:mm' }}
                    </span>
                    <span *ngIf="employee.currentWorkDay.cellType && employee.currentWorkDay.cellType.ct_id !== 1">
                      {{ employee.currentWorkDay.cellType.ct_name }}
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="content-item content-item__time js-content-item__time timeline">
            <div class="content-time-block__wrapper js-content-time-block__wrapper" [class.content-time-block__wrapper-grs]="isGRS">
              <div
                class="time-block"
                *ngFor="let day of employee.groupByDays?.days; trackBy: trackByFn"
                [attr.data-content-date]="day.workday"
                (click)="onOpenChangeStatusDialog(employee)"
              >
                <div
                  class="time-block__item"
                  *ngFor="let time of day.times; trackBy: trackByIndex"
                  [attr.data-content-time]="time"
                  [attr.data-content-date]="day.workday"
                  id="{{ 'employee_' + employee.u_id + '_' + day.workday + '_' + time }}"
                ></div>
                <app-employee-work-interval [workInterval]="day.workInterval" [workday]="day.workday" [employeeId]="employee.u_id"> </app-employee-work-interval>
                <app-employee-work-statuses [workStatuses]="day.workStatuses" [workday]="day.workday" [employeeId]="employee.u_id"> </app-employee-work-statuses>
              </div>
            </div>
          </div>
          <div class="content-item content-item__worked" *ngIf="employee.groupByDays">
            <app-employee-worked [currentDate]="currentDate" [worked]="$safeNavigationMigration(employee.groupByDays?.worked)"> </app-employee-worked>
          </div>
        </div>
      </ng-container>
      <div *ngIf="employers && !employers.length" class="padding-48 ta-center color-gray">Не найдено ни одного сотрудника.</div>
    </div>
  </div>
</div>
